import { useStore } from "@nanostores/preact"
import { useTranslation } from "../components/Translation"
import { profile } from "../services/store"
import css from "../style.module.scss"
import checkIcon from "../static/icon-check--white.svg"
import promoImg from "../static/app-mockup.png"
import playStore from "../../app-store/static/google-play.svg"
import appStore from "../../app-store/static/ios.svg"

export function Success({
  onClose,
  onEmailVerify,
}: {
  onClose: () => void
  onEmailVerify?: () => void
}) {
  const t = useTranslation()
  const user = useStore(profile)

  return (
    <div className={css.content}>
      <div className={css["success-icon"]}>
        <img src={checkIcon} alt="Check icon" width={40} height={40} />
      </div>
      <h3 className={css["success-title"]}>{t("thanks_for_subscribing")}</h3>
      <p className={css["success-text"]}>{t("you_have_access")}</p>

      <div className={css["app-promo-container"]}>
        <div className={css["app-promo-image-container"]}>
          <img src={promoImg} alt="App Screenshot" className={css["app-promo-image"]} />
        </div>
        <div className={css["app-promo-bg-image-container"]} />
        <div className={css["app-promo-text-container"]}>
          <p className={css["app-promo-title"]}>{t("the_forecast_in_your_pocket")}</p>
          <p className={css["app-promo-text"]}>{t("elevate_your_adventures")}</p>
          <div className={css["app-promo-links"]}>
            <a
              href="https://apps.apple.com/gb/app/surf-forecast-by-surf-forecast/id6450721636"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={appStore} alt="App Store" className={css["app-link"]} />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.snowfore.surfforecast.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={playStore} alt="Google Play" className={css["app-link"]} />
            </a>
          </div>
        </div>
      </div>
      <button
        className={css.submit}
        type="button"
        onClick={() => {
          if (!user.emailVerified && onEmailVerify) {
            onEmailVerify()
          } else {
            onClose()
          }
        }}
      >
        {!user.emailVerified ? t("verify_email") : t("finish")}
      </button>
    </div>
  )
}
